import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const Concept = ({ index, isCorrect, score, text, spanStyle }) => (
    <div className={`paragraph-holder ${index % 2 !== 0 ? 'second' : ''}`}>
        <p className="paragraph-question">{text}</p>
        <span style={spanStyle} className={`indication ${isCorrect ? 'done' : 'cancel'}`} />
        <p className="number">{score}</p>
    </div>
);

Concept.defaultProps = {
    index: 0,
    isCorrect: false,
    score: null,
    text: null,
    spanStyle: {},
};
Concept.propTypes = {
    index: PropTypes.number,
    isCorrect: PropTypes.bool,
    score: PropTypes.number,
    text: PropTypes.string,
    spanStyle: PropTypes.object,
};

const ConceptsList = ({ kopItems }) =>
    kopItems.map(({ concept, correct, groupCorrect, subItems }, index) => (
        <Fragment key={generateReactKey(index)}>
            <Concept
                index={index}
                isCorrect={correct}
                score={groupCorrect ? 1 : 0}
                text={concept}
            />
            {isEmpty(subItems)
                ? null
                : subItems.map((subItem, subIndex) => {
                      return (
                          <Concept
                              key={generateReactKey(subIndex, subItem.concept)}
                              index={index}
                              isCorrect={subItem.correct}
                              text={subItem.concept}
                              spanStyle={{ bottom: 0 }}
                          />
                      );
                  })}
        </Fragment>
    ));

ConceptsList.defaultProps = {
    kopItems: [],
};

ConceptsList.propTypes = {
    kopItems: PropTypes.array,
};

export default ConceptsList;
